import { IconButton, Typography } from '@mui/material';
import { EditIcon, ListRow } from '@schooly/style';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { getTimetableStatus } from './utils';

export type TimetableRowProps = {
  id: string;
  name: string;
  publishedAt: string | null;
  isPastYear: boolean;
  canManageTimetables: boolean;
};

export const TimetableRow: FC<TimetableRowProps> = ({
  id,
  name,
  publishedAt,
  isPastYear,
  canManageTimetables,
}) => {
  const navigate = useNavigate();
  const statusInfo = getTimetableStatus(publishedAt, isPastYear);

  const canEdit = canManageTimetables && !isPastYear;

  const handleClick = () => {
    navigate(`/settings/timetables/${canEdit ? `${id}/edit` : id}`);
  };

  return (
    <ListRow
      title={name}
      onClick={handleClick}
      rightContent={
        <Typography color={statusInfo.color} sx={{ minWidth: 126 }}>
          <FormattedMessage id={statusInfo.labelId} />
          {statusInfo.publishedDate && ` ${statusInfo.publishedDate}`}
        </Typography>
      }
      actions={
        canEdit && (
          <IconButton
            className="actionIcon"
            size="small"
            sx={{ visibility: 'hidden', position: 'absolute', right: 12 }}
          >
            <EditIcon />
          </IconButton>
        )
      }
      sx={{
        '&:hover .actionIcon': { visibility: 'visible' },
      }}
    />
  );
};
